import { render } from "./Top5View.vue?vue&type=template&id=77236684&scoped=true"
import script from "./Top5View.vue?vue&type=script&lang=js"
export * from "./Top5View.vue?vue&type=script&lang=js"

import "./Top5View.vue?vue&type=style&index=0&id=77236684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77236684"]])

export default __exports__